exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#services[data-v-0efc4570]{padding-top:50px;padding-bottom:150px}.square[data-v-0efc4570]{background-color:#fff;height:300px;width:33%;border:2px solid #e3e3e3;border-radius:5px}.square.last[data-v-0efc4570]{width:calc(33% - 6px)}.square h4[data-v-0efc4570]{font-weight:700;font-size:20px}.square i[data-v-0efc4570]{font-size:110px;margin-bottom:30px}.square img[data-v-0efc4570]{height:110px;margin-bottom:30px}@media (max-width:414px){.square.last[data-v-0efc4570],.square[data-v-0efc4570]{width:100%;margin-bottom:5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0efc4570","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Services.vue
// module id = 71
// module chunks = 0